import { useMemo, useState } from "react";
import { genreTabs, works } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function WorksSection() {
  const [active, setActive] = useState("all");

  const filtered = useMemo(
    () => (active === "all" ? works : works.filter((w) => w.genre === active)),
    [active],
  );

  return (
    <section id="works" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="作品合集"
          title="人气同人漫画与本子条目"
          desc="以下条目按剧情设定归类，每条都标注了篇幅、评分与标签。点击上方标签即可筛选你想要的基调，筛选只作用于本页已收录的内容。"
        />

        <div
          role="tablist"
          aria-label="按题材筛选作品"
          className="mt-8 md:mt-10 flex flex-wrap gap-2"
        >
          {genreTabs.map((tab) => {
            const isActive = active === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(tab.id)}
                className={`px-1 py-1 rounded-full transition-colors cursor-pointer ${
                  isActive ? "bg-primary-500" : "bg-background-200/70 hover:bg-background-300/70"
                }`}
              >
                <span
                  className={`block px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap ${
                    isActive ? "text-background-50" : "text-foreground-700"
                  }`}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-sm text-foreground-500">
          共 <strong className="text-foreground-900 font-semibold">{filtered.length}</strong> 条作品
          {active !== "all" && ` · 当前筛选：${genreTabs.find((t) => t.id === active)?.label}`}
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {filtered.map((work) => (
            <article
              key={work.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 flex flex-col"
            >
              <div className="relative w-full h-56 md:h-60 overflow-hidden">
                <img
                  src={work.cover}
                  alt={`《${work.title}》同人漫画封面插画，${work.genreLabel}风格`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
                  <i className="ri-star-fill text-accent-400"></i>
                  {work.rating}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
                    {work.genreLabel}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    {work.chapters}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  《{work.title}》
                </h3>
                <p className="mt-1 text-xs text-foreground-500">画师：{work.author}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">
                  {work.summary}
                </p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {work.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-background-200/70 text-foreground-700 text-xs"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            该分类下暂时没有收录条目，换个标签看看。
          </p>
        )}
      </div>
    </section>
  );
}